<div class="page-container">
  <div class="landing-content scrollable-content">
    <div class="logo-section">
      <img [src]="'logos/app-icon.png' | envPrefix" [attr.alt]="'landing.title' | translate" class="logo" />
      <h1>{{ 'landing.title' | translate }}</h1>
      <p class="tagline">{{ 'landing.tagline' | translate }}</p>
    </div>


    <div class="features">
      <div class="feature">
        <h3>{{ 'landing.feature.offline.title' | translate }}</h3>
        <p>{{ 'landing.feature.offline.description' | translate }}</p>
      </div>
      <div class="feature">
        <h3>{{ 'landing.feature.sync.title' | translate }}</h3>
        <p>{{ 'landing.feature.sync.description' | translate }}</p>
      </div>
      <div class="feature">
        <h3>{{ 'landing.feature.team.title' | translate }}</h3>
        <p>{{ 'landing.feature.team.description' | translate }}</p>
      </div>
    </div>

    <div class="cta-section">
      <button class="btn-primary cta-button" routerLink="/login" data-testid="get-started-button">
        {{ 'landing.getStarted' | translate }}
      </button>

      <p class="terms">
        {{ 'landing.termsPrefix' | translate }}
        <a routerLink="/terms" data-testid="landing-terms-link">{{ 'legal.termsOfService' | translate }}</a>
        {{ 'landing.termsAnd' | translate }}
        <a routerLink="/privacy" data-testid="landing-privacy-link">{{ 'legal.privacyPolicy' | translate }}</a>
      </p>

      <a routerLink="/pricing" class="pricing-link" data-testid="view-pricing-link">
        {{ 'landing.viewPricing' | translate }}
      </a>
    </div>
  </div>
</div>